//  bootstrap
import { useState, useEffect } from "react";

// icons
import { EditIcon, CheckIcon } from "../Icons/Icons";

// style
import "./AddressItem.scss";

// components
import Drawer from "../../drawer/Drawer";
import AddressManage from "../../address/AddressManage";

import useWindowSize from "../../../hooks/useWindowSize";

export default function AddressItem({
  id,
  title,
  address,
  selected,
  hasRadioBtn,
  RadioBtnFunc,
  item,
  updateAddress,
  buttonShow = true,
  underLine = false,
}) {
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const windowSize = useWindowSize();
  const [height, setHeight] = useState(627);
  const [component, setComponent] = useState(<></>);
  useEffect(() => {
    windowSize.height > 660 ? setHeight(648) : setHeight("85%");
  }, [windowSize]);
  return (
    <>
      <div className="address-container d-flex align-items-center">
        {hasRadioBtn && (
          <span
            className={`rounded-pill border my-auto ${
              selected && "bg-active"
            } d-flex me-1`}
            style={{ width: 20, height: 20, cursor: "pointer  " }}
            onClick={() => RadioBtnFunc(id)}
          >
            {selected && (
              <CheckIcon
                width="10px"
                height="10px"
                containerIconClassName={"d-flex mx-auto my-auto"}
              />
            )}
          </span>
        )}
        <div id={`address-${id}`} type="radio" className="address-item d-flex">
          <div>
            <div className="title title-h5-m  d-flex align-items-center text-start">
              {title == "" ? "------" : title}
            </div>
            <div className="description desc-l d-flex align-items-center text-start">
              {address.split("&")[0] + "،" + address.split("&")[1]}
            </div>
          </div>
        </div>

        <div>
          {buttonShow && (
            <button
              className="border-0 edit-icon"
              onClick={() => {
                setIsOpenDrawer(!isOpenDrawer);
                setHeight(648);
                setComponent(
                  <AddressManage
                    setIsOpenDrawer={setIsOpenDrawer}
                    setHeight={setHeight}
                    setComponent={setComponent}
                    itemInfo={item}
                    updateAddress={updateAddress}
                  />
                );
              }}
            >
              <EditIcon containerIconClassName="mr-auto" />
            </button>
          )}
          {
            <Drawer
              isOpen={isOpenDrawer}
              onClose={() => setIsOpenDrawer(false)}
              height={height}
            >
              <div className="demo-content pd-x-16">{component}</div>
            </Drawer>
          }
        </div>
      </div>
      {underLine && <hr className="mr-r-40" />}
    </>
  );
}
